'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dGroupings$0024 from "./presto.-List-Groupings$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002463 from "./presto.-Presto-Router$$anon$63.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$62() {
  this.bm7 = null;
  this.blZ = null;
  this.bm0 = false;
  this.bm8 = null;
  this.bm9 = false;
  this.bmc = null;
  this.bm5 = null;
  this.bm6 = false;
  this.bm1 = null;
  this.bm2 = false;
  this.bm3 = null;
  this.bm4 = false;
  this.bma = false;
  this.bmb = false;
  this.bm7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmc = "ListGroupings";
}
export { $c_Lpresto_PrestoRouter$$anon$62 as $c_Lpresto_PrestoRouter$$anon$62 };
$p = $c_Lpresto_PrestoRouter$$anon$62.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$62;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$62() {
}
export { $h_Lpresto_PrestoRouter$$anon$62 as $h_Lpresto_PrestoRouter$$anon$62 };
$h_Lpresto_PrestoRouter$$anon$62.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bm7;
});
$p.M = (function() {
  if ((!this.bm0)) {
    this.blZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bm0 = true;
  }
  return this.blZ;
});
$p.O = (function() {
  if ((!this.bm9)) {
    this.bm8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bm9 = true;
  }
  return this.bm8;
});
$p.D = (function() {
  return this.bmc;
});
$p.t = (function() {
  if ((!this.bm6)) {
    this.bm5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bm6 = true;
  }
  return this.bm5;
});
$p.N = (function() {
  if ((!this.bm2)) {
    this.bm1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bm2 = true;
  }
  return this.bm1;
});
$p.Q = (function() {
  if ((!this.bm4)) {
    this.bm3 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002463.$c_Lpresto_PrestoRouter$$anon$63();
    this.bm4 = true;
  }
  return this.bm3;
});
$p.v = (function() {
  if ((!this.bmb)) {
    this.bma = false;
    this.bmb = true;
  }
  return this.bma;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee454) => ((p) => \u03b4scrutinee454))($j_presto$002e$002dList$002dGroupings$0024.$m_Lpresto_ListGroupings$())));
});
var $d_Lpresto_PrestoRouter$$anon$62 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$62, "presto.PrestoRouter$$anon$62", ({
  OD: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$62 as $d_Lpresto_PrestoRouter$$anon$62 };
//# sourceMappingURL=presto.-Presto-Router$$anon$62.js.map
